import React from 'react';
import { useUserContext } from '@magoosh/context/user_context';
import { Checkpoint } from '@magoosh/gre/organisms/checkpoints/types';
import AssessmentCheckpoint from '@magoosh/gre/organisms/checkpoints/assessment';
import PracticeTestCheckpoint from '@magoosh/gre/organisms/checkpoints/practice_test';
import TestDayCheckpoint from '@magoosh/gre/organisms/checkpoints/test_day';

interface Props {
  checkpoints: Checkpoint[];
}

const CheckpointsTab:React.FC<Props> = (props) => {
  const { testDate } = useUserContext();

  const { checkpoints } = props;

  return (
    <>
      <h3 className="u-margin-V-s">
        <strong>Checkpoints</strong>
      </h3>
      <p>When you unlock a checkpoint you’ll see it at the top of your study plan until it expires.</p>

      {
        checkpoints.map((checkpoint, idx) => {
          if (checkpoint.type === 'Assessment') {
            return (
              <AssessmentCheckpoint checkpoint={checkpoint} key={idx} />
            );
          } else if (checkpoint.type === 'Practice Test') {
            return (
              <PracticeTestCheckpoint checkpoint={checkpoint} key={idx} />
            );
          } else if (checkpoint.type === 'Test Day') {
            return (
              <TestDayCheckpoint checkpoint={checkpoint}  key={idx} testDate={testDate} />
            );
          }
        })
      }
    </>
  );
};

export default CheckpointsTab;
